import { useQuery } from '@apollo/react-hooks';
import { Button, Tooltip, ButtonGroup } from '@material-ui/core';
import History from '@jda/lui-common-icon-library/ui/History';
import React, { useEffect } from 'react';
import DetailedTable from '../../components/DetailedTable';
import { Loading } from '../../Loading';
import { TRANSFORM_SPEC_LIST, USER_DETAILS } from '../graphQL/queries';
import columns from './columns';
import ArrowChevronUp from '@jda/lui-common-icon-library/ui/ArrowChevronUp';
import Edit from '@jda/lui-common-icon-library/ui/Edit';
import ViewDetails from '@jda/lui-common-icon-library/ui/ViewDetails';
import HistoryDetailView from './HistoryDetailView';
import TransformGrid from '../../components/Transformation';

type specObj = {
  operationCode: string;
  type: string;
  httpStatus: number;
  spec: string;
};

type responseObj = {
  TransformSpecInfo: specObj[];
};

interface TransformationSpecGridProps {
  participant: any;
  workflowCode: string;
}

const TransformationSpecGrid = (props: TransformationSpecGridProps) => {
  let { participantCode } = props.participant;
  const { data: userData } = useQuery(USER_DETAILS, { fetchPolicy: 'cache-only' });
  const [addSpecDialog, isAddSpecDialog] = React.useState<any>(false);
  const [edit, isEdit] = React.useState<any>(false);
  const [specData, setSpecData] = React.useState<any>({});
  const [userRole, setUserRole] = React.useState('');
  const [selectedKey, setSelectedKey] = React.useState('JOLT');
  const [joltData, setJOLTData] = React.useState<any>([]);
  const [liquidData, setLIQUIDData] = React.useState<any>([]);

  useEffect(() => {
    setUserRole(userData?.userProfile?.roles?.[0]);
  }, [userData]);

  const { loading, data, refetch } = useQuery<any, {}>(TRANSFORM_SPEC_LIST, {
    variables: { participantCode: participantCode, workflowCode: props.workflowCode },
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    let joltDataList: any = [];
    let liquidDataList: any = [];
    (data?.TransformSpecInfo || []).forEach((arr: any) => {
      if (arr?.transformType === 'JOLT') {
        joltDataList.push(arr);
      } else if (arr?.transformType === 'LIQUID') {
        liquidDataList.push(arr);
      }
    });
    setJOLTData(joltDataList);
    setLIQUIDData(liquidDataList);
  }, [data]);

  const tableActions: any = [
    {
      icon: () => (
        <ButtonGroup size="small" aria-label="outlined primary button group">
          <Button
            data-id="JOLT-TransformationTab"
            onClick={() => handleTransformationTabs('JOLT')}
            variant={selectedKey === 'JOLT' ? 'contained' : 'outlined'}
            color="primary"
          >
            Jolt
          </Button>
          <Button
            data-id="LIQUID-TransformationTab"
            onClick={() => handleTransformationTabs('LIQUID')}
            variant={selectedKey === 'LIQUID' ? 'contained' : 'outlined'}
            color="primary"
          >
            Liquid
          </Button>
        </ButtonGroup>
      ),
      isFreeAction: true,
      onClick: () => {}
    },
    userRole === 'APP_ADMIN' && {
      icon: () => (
        <Button variant="outlined" onClick={handleAddSpecDialog} data-id="Add-spec" id="Add-spec" color="primary">
          Add
        </Button>
      ),
      onClick: () => {},
      isFreeAction: true
    },
    userRole === 'APP_ADMIN'
      ? {
          icon: () => <Edit data-id="edit-transform-spec" />,
          onClick: (event: any, rowData: any) => handleEditSpecDialog(rowData)
        }
      : {
          icon: () => <ViewDetails />,
          onClick: (event: any, rowData: any) => handleEditSpecDialog(rowData),
          tooltip: 'View Details',
          position: 'row'
        }
  ];

  const handleTransformationTabs = (key: any) => {
    setSelectedKey(key);
  };

  const handleAddSpecDialog = () => {
    isEdit(false);
    isAddSpecDialog(true);
  };

  const handleEditSpecDialog = (rowData: any) => {
    isAddSpecDialog(true);
    isEdit(true);
    setSpecData(rowData);
  };

  const handleAddSpecDialogClose = () => {
    isAddSpecDialog(false);
    setSpecData({});
  };

  const getTransformationData = () => {
    if (selectedKey === 'JOLT') {
      return !loading ? joltData : [];
    } else if (selectedKey === 'LIQUID') {
      return !loading ? liquidData : [];
    }
  };

  const detailPanel = [
    {
      icon: () => (
        <div>
          <Tooltip title="View History" aria-label="simple">
            <History />
          </Tooltip>
        </div>
      ),
      tooltip: 'Show History',
      openIcon: () => <ArrowChevronUp />,
      render: (rowData: any) => {
        return (
          <HistoryDetailView
            {...rowData}
            workflowCode={props.workflowCode}
            participantCode={participantCode}
            historyRefetch={refetch}
            supportUser={userRole}
          />
        );
      }
    }
  ];

  return (
    <div>
      <TransformGrid
        id="TransformGrid"
        open={addSpecDialog}
        handleDialogClose={handleAddSpecDialogClose}
        edit={edit}
        specData={specData}
        workflowCode={props.workflowCode}
        refetch={refetch}
        supportUser={userRole !== 'APP_ADMIN' ? true : false}
        selectedKey={selectedKey}
      />
      {loading ? (
        <Loading />
      ) : (
        <DetailedTable
          id="TransformSpec"
          data-id="TransformSpec"
          title=""
          columns={columns}
          data={getTransformationData()}
          showSelection={false}
          tableActions={tableActions}
          detailPanel={detailPanel}
          showPagination={true}
          page={0}
          rowsPerPage={10}
        />
      )}
    </div>
  );
};
export default TransformationSpecGrid;
